<div *ngIf="data">
  <mat-chip-list>
    <mat-chip class="chip" *ngFor="let tag of data.tags">{{
      tag.tagName
    }}</mat-chip>
  </mat-chip-list>
</div>
